module.exports = __webpack_public_path__ + "img/ai.63717e9a.svg";